/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 1rem 0rem",
  },
  heading: {
    width: "100%",
    color: "#0FCA56",
    // background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    fontWeight: "600",
    fontSize: "1.75rem",
    lineHeight: "3.1875rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  subHeading: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#666666",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.6875rem",
    },
  },
}));

const PrivacyContent = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Typography variant="h4" component="span" className={classes.heading}>
          PRIVACY POLICY STATEMENT
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          The aim of this privacy policy statement is to inform You regarding
          the Company’s practices in relation to collection, use, disclosure and
          transfer of Personal Information that is either provided by You or
          collected by the Company through Your use of the Online Platform{" "}
          <b>(“Privacy Policy”)</b>.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          Sentient Developers Pvt. Ltd. (as used herein, the name &quot;
          Sentient &quot; includes Sentient Developers Pvt. Ltd., and all
          companies subsidiary wholly or partially owned by it) makes every
          effort to handle your personal information as safely and securely as
          reasonably possible.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          When you visit our websites or use our services, you’re trusting us
          with your information and we fully understand that this is a big
          responsibility and we take all reasonable measures to safeguard and
          protect your information.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          This Privacy Policy is meant to help you understand what information
          we collect, why we collect it, and how you can update and manage your
          information.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          As described below, your information may be collected by Sentient,
          disclosed to third parties, and used by third parties and Sentient.
          This Privacy Policy describes the information we collect from you and
          how we may use that information. Some of the reasons why we collect
          your personal information include:
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          <li>
            To register you so that you access parts and services of the
            Sentient and affiliated websites
          </li>
          <li>To register you so that you may use access “Sentient” App</li>
          <li>To register you so that you may subscribe to our newsletters</li>
          <li>
            So that you may participate in discussion forums and blogs on our
            site
          </li>
          <li>
            To perform verification / validation of identity, where applicable
          </li>
          <li>
            To provide you with timely and relevant information through
            post/courier, SMS, Telephone / GSM, E-Mail and social media channels
          </li>
          <li>
            To provide you with a more personalized and meaningful experience on
            the Sentient and affiliated sites.
          </li>
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          We occasionally employ other companies and individuals to perform
          functions on our behalf. For example, other companies and individuals
          may fulfil your orders from us, send you postal mail and e-mail,
          remove repetitive information from our customer lists, analyse our
          data, provide us with marketing assistance, and process credit card
          payments. These third-party service providers have access to personal
          information needed to perform their functions, and may not use it for
          other purposes.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          When you voluntarily send us electronic mail / fillup the form, we will keep a record of this information so that we can respond to you. We only collect information from you when you register on our site or fill out a form. Also, when filling out a form on our site, you may be asked to enter your: name, e-mail address or phone number. You may, however, visit our site anonymously. In case you have submitted your personal information and contact details, we reserve the rights to Call, SMS, Email or WhatsApp about our products and offers, even if your number has DND activated on it.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          We do not intend to disclose any personal information of yours without
          your consent to any third party who is not bound to act on our behalf
          unless such disclosure is required by law.
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          <b>Copyright</b>
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          The content on this website is the exclusive property of Sentient
          Developers Private Limited.
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default PrivacyContent;
